import SurvivorLobby from './SurvivorLobby';
export default SurvivorLobby;